<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <a-card :bordered="false">
      <a-skeleton v-if="loading" />
      <a-list :dataSource="dataSourceTop" >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="item-card" @click="toDetail(item)" :bordered="false">
            <a-row :gutter="24" justify="space-between">
              <a-col :span="_isMobile()?24:isBigCover(item)?18:6">
                <div class="img-zoom">
                  <img class="cover" :src="item.eventCover_url" alt="" />
                </div>
              </a-col>
              <a-col v-if="isBigCover(item)" :span="_isMobile()?24:6" class="item-desc">
                <h2>
                  <a-tag v-if="item.eventStatus==0">未开始</a-tag>
                  <a-tag v-if="item.eventStatus==-1">已结束</a-tag>
                  <a-tag color="green" v-if="item.eventStatus==1 || item.eventStatus==2">进行中</a-tag>
                  {{ item.eventName }}</h2>
                <h3>{{ getDictValue(item.eventCategory) }}</h3>
                <br />
                <span>开始时间：{{ item.eventBegin }}</span>
                <br>
                <span>到期时间：{{ item.eventEnd }}</span>
                <br><br>
                <span class="btn" @click="toDetail(item)">点击进入</span>
              </a-col>
              <a-col v-else :span="_isMobile()?24:18" class="item-desc">
                <div>
                  <h2 style="display: inline;">
                    <a-tag v-if="item.eventStatus==0">未开始</a-tag>
                    <a-tag v-if="item.eventStatus==-1">已结束</a-tag>
                    <a-tag color="green" v-if="item.eventStatus==1 || item.eventStatus==2">进行中</a-tag>
                  {{ item.eventName }}</h2>
                  <a-divider type="vertical"></a-divider>
                  <a-icon type="calendar" theme="twoTone" />
                  <span> 活动时间：{{ item.eventBegin }} ~ {{ item.eventEnd }}</span>
                </div>
                <br>
                <div v-html="item.eventDesc"></div>
              </a-col>
            </a-row>
          </a-card>
        </a-list-item>
      </a-list>
      <a-list :grid="{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }" :dataSource="dataSource" :pagination="pagination">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card :bordered="false" class="item-card" @click="toDetail(item)">
            <a-row :gutter="24" justify="space-between">
              <a-col :span="24">
                <div class="img-zoom">
                  <img class="cover" :src="item.eventCover_url" alt="" />
                </div>
              </a-col>
              <a-col :span="24" class="item-desc">
                <div>
                  <a-tag v-if="item.eventStatus==0">未开始</a-tag>
                  <a-tag v-if="item.eventStatus==-1">已结束</a-tag>
                  <a-tag color="green" v-if="item.eventStatus==1 || item.eventStatus==2">进行中</a-tag>
                  <br>
                  <h2 style="display: inline;">{{ item.eventName }}</h2>
                  <br><br>
                  <a-row>
                    <a-col :span="18">
                      <span>开始时间：{{ item.eventBegin }}</span>
                      <br>
                      <span>到期时间：{{ item.eventEnd }}</span>
                    </a-col>
                    <a-col :span="6">
                      <span class="btn" @click="toDetail(item)">点击进入</span>
                    </a-col>
                  </a-row>
                </div>
                <br>
                <div v-html="item.eventDesc"></div>
              </a-col>
            </a-row>
          </a-card>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import { loadCategoryData } from "@/api/api";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import PhotoCard from "@/components/common/PhotoCard";
// import JCategorySelect from "@comp/jeecg/JCategorySelect";
import { filterMultiDictText } from "@comp/jeecg/JDictSelectUtil";
import "@/assets/less/animation.css";

export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
    PhotoCard,
    // JCategorySelect,
  },
  data() {
    return {
      dataSourceTop: [],
      dataSource: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: this._isMobile() ? 8 : 12,
      },
      loading: true,
      productType: "",
      tenantConfig: {},
      videoVisible: false,
      currentItem: {},
      queryParam: {
        column: 'createTime',
        order: 'desc',
        pageSize: 999,
      },
      dictOptions: {},
    };
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if(this.$route.query.type){
      this.queryParam.eventType = this.$route.query.type
    }
    this.getTopList()
    this.getList();
    // loadCategoryData({ code: "A05" }).then((res) => {
    //   if (res.success) {
    //     this.$set(this.dictOptions, "eventCategory", res.result);
    //   }
    // });
  },
  mounted() {},
  methods: {
    getTopList(){
      this.dataSourceTop = [];
      this.queryParam.eventStatusList = '2'
      this.queryParam.pageNo = 1
      this.queryParam.pageSize = 3
      let formData = Object.assign({}, this.queryParam);
      getAction(
        "/teaching/teachingEvent/getAvailableEvent",
        formData
      ).then((res) => {
        console.log(res);
        if (res.success) {
          this.dataSourceTop = res.result.records;
        }
        this.loading = false;
      });
    },
    getList() {
      this.loading = true;
      this.dataSource = [];
      this.queryParam.pageNo = 1
      this.queryParam.pageSize = 999
      this.queryParam.eventStatusList = '-1,0,1'
      let formData = Object.assign({}, this.queryParam);
      getAction(
        "/teaching/teachingEvent/getAvailableEvent",
        formData
      ).then((res) => {
        console.log(res);
        if (res.success) {
          this.dataSource = res.result.records;
        }
        this.loading = false;
      });
    },
    isBigCover(record){
      if(record.showConfig){
        console.log(record.showConfig);
        let showConfig = JSON.parse(record.showConfig)
        
        return showConfig.bigCover == undefined ? true: showConfig.bigCover
      }else{
        return true
      }
    },
    eventChange(v) {
      this.queryParam.eventId = v.target.value;
      this.getList();
    },
    onEventCategory(v) {
      this.queryParam.eventCategory = v;
      this.getList();
    },
    getDictValue(text) {
      return text
        ? filterMultiDictText(this.dictOptions["eventCategory"], text)
        : "";
    },
    toDetail(item) {
      let route = this.$router.resolve({
        path: "/event/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.img-zoom {
  width: 100%;
  max-height: 270px;
  border-radius: 4px;
  box-shadow: rgb(179, 179, 179) 0px 0px 5px;
  img {
    width: 100%;
    height: 100%;
  }
}
.btn{
  display: inline-block;
  background:linear-gradient(180deg, rgb(250,194,44), rgb(255,101,73));
  border-radius:5px;
  padding:8px 16px;
  color:white;
  font-size: 14px;
  cursor: pointer;
}
.item-card {
  width: 100%;
  .item-desc {
    padding: 20px;
  }
}
.title {
  margin-top: 5px;
}
.title:hover {
  color: #1890ff;
}
.search-card {
  /deep/.ant-card-body {
    padding: 20px;
  }
}
/deep/.ant-list-item {
  cursor: pointer;
  .ant-card-body {
    padding: 0;
  }
}
.mobile {
  .cover {
    height: 100px !important;
  }
}
</style>